import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const NRTBullet = ({
                       bulletNumber,
                       activeBullet,
                       content,
                       title,
                   }) => {

    const classes = []

    if (Array.isArray(bulletNumber)) {

        if (bulletNumber.some(b => b === activeBullet))
            classes.push('active')
        else if (!bulletNumber.some(b => b > activeBullet))
            classes.push('concluded')

    } else {
        if (bulletNumber === activeBullet)
            classes.push('active')

        if (activeBullet > bulletNumber)
            classes.push('concluded')
    }


    return (
        <div className={'nrt-bullet ' + classes.join(' ')}>

            <h4 className="content">
                {content}

                {
                    title &&
                    <span className={'title'}>
                        {title}
                    </span>
                }

            </h4>


        </div>
    )
}

NRTBullet.propTypes = {
    bulletNumber: PropTypes.any.isRequired,
    activeBullet: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
    title: PropTypes.string,
}

NRTBullet.defaultProps = {}

export default NRTBullet



// WEBPACK FOOTER //
// ./src/components/_common/BulletList/Bullet/index.js